module.exports = __webpack_public_path__ + "0705fa45a8bbeaaec52d50655b2967fd.png";